const TRUST_ITEMS = [
  { icon: 'ri-shield-check-line', label: 'Fully Insured' },
  { icon: 'ri-group-line', label: 'Professional Crew' },
  { icon: 'ri-medal-line', label: 'Proven Results' },
  { icon: 'ri-map-pin-2-line', label: 'Tampa Bay & Sarasota' },
  { icon: 'ri-star-line', label: '5-Star Service' },
];

export default function TrustBar() {
  return (
    <section className="bg-[#f4f0ea] border-b border-[#e5e0d8] py-6">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <p className="text-center text-[#6b6560] text-xs uppercase tracking-widest mb-5">
          Trusted by homeowners and builders across Tampa Bay
        </p>
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-12">
          {TRUST_ITEMS.map((item, idx) => (
            <div key={item.label} className="flex items-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className={`${item.icon} text-[#c9a55a] text-lg`} />
              </div>
              <span className="text-[#4a4540] text-sm font-medium whitespace-nowrap">{item.label}</span>
              {idx < TRUST_ITEMS.length - 1 && (
                <span className="hidden md:block text-[#d0cbc5] text-lg ml-6">|</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
